import styles from './styles.module.scss';

const Background = (props) => {


    
    return (
        <div className={`${styles.backgroundColorBlackout} ${props.xmas && styles['backgroundColorBlackout--xmas']} ${props.halloween && styles['backgroundColorBlackout--halloween']} ${styles[`width--100P`]} ${styles[`height--100P`]}`}
        style={{
            position: "fixed",
            zIndex: -1
        }}
        >

        </div>
    );
}


export default Background;